<template>
    <div class="trainingCourseManagementWarp">
        <div class="titleBox">培训课程管理</div>
        <!-- <div class="courseTabBox">
            <div v-for="(item,index) in CourseTabs" :key="index" :class="activeName==item.name?'activcourseItem':'courseItem'" @click="changeTabs(item)">
                {{item.name}}
            </div>
        </div> -->
        <div class="tableBox">
            <ApplyCourse/>
            <!-- <div v-if="activeName=='已报名课程'">
                <ApplyCourse/>
            </div>
            <div v-if="activeName=='已完成课程'">
                <CompleteCourse/>
            </div> -->
        </div>
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import ApplyCourse from './ApplyCourse.vue'
import CompleteCourse from './CompleteCourse.vue'

export default {
    components: {
        ApplyCourse,
        CompleteCourse
    },
    data() {
        return {
            srcUrl: srcUrl,
            activeName: '已报名课程',
            CourseTabs: [
                { name: '已报名课程' },
                { name: '已完成课程' },
            ]

        }
    },
    mounted() {

    },
    methods: {
        changeTabs(item) {
            this.activeName = item.name
        }

    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.trainingCourseManagementWarp {
	width: 100%;
    padding: 20px 61px 0 50px;
	box-sizing: border-box;
	.titleBox {
		font-size: 24px;
		font-weight: bold;
		line-height: 24px;
		color: #43424b;
		margin-bottom: 32px;
	}
	.courseTabBox {
		display: flex;
		flex-direction: row;
		font-size: 16px;
		padding: 0 0 5px 0px;
		border-bottom: 1px solid #0083ff;

		.activcourseItem {
			width: 124px;
			height: 42px;
			line-height: 42px;
			background: #349cff;
			border-radius: 5px;
			text-align: center;
			color: #fff;
			margin: 0 20px;
			cursor: pointer;
		}
		.courseItem {
			width: 124px;
			height: 42px;
			text-align: center;
			line-height: 42px;
			color: #43424b;
			margin: 0 20px;
			cursor: pointer;
		}
	}
}
</style>


